export interface Movie {
  id: string;
  title: string;
  cover: string;
  summary: string;
  story: string;
  category: string;
  subCategory: string;
  region: string;
  year: number;
  genres: string[];
  director: string;
  actors: string[];
  rating: number;
  updateDate: string;
  episodes: string;
  hot: number;
  tags: string[];
}

export const movieCategories = [
  { key: "电影", label: "电影", desc: "院线大片与热门电影作品", icon: "ri-film-line", sub: ["动作", "科幻", "爱情", "悬疑", "剧情", "奇幻"] },
  { key: "电视剧", label: "电视剧", desc: "热播电视剧与追更剧集", icon: "ri-tv-2-line", sub: ["都市剧", "年代剧", "悬疑剧", "青春剧", "古装剧", "家庭剧"] },
  { key: "综艺", label: "综艺", desc: "音乐、竞技与户外真人秀", icon: "ri-mic-line", sub: ["音乐", "真人秀", "竞技", "访谈", "生活"] },
  { key: "纪录片", label: "纪录片", desc: "自然、人文与美食纪实影像", icon: "ri-earth-line", sub: ["自然", "美食", "人文", "历史", "科学"] },
];

export const regions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国"];
export const years = ["全部", "2026", "2025", "2024", "2023", "2022"];

export const movies: Movie[] = [
  {
    id: "1001",
    title: "深空回响",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%2C%20astronaut%20silhouette%20facing%20a%20vast%20glowing%20deep%20space%20nebula%2C%20dark%20teal%20and%20amber%20lighting%2C%20dramatic%20mood%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1001&orientation=portrait",
    summary: "一支深空探测队接收到来自未知星域的神秘信号，由此揭开人类文明起源的惊人秘密。",
    story: "《深空回响》讲述近未来人类首次接收到一段来自银河系边缘的规律信号。语言学家林澈与天体物理学家程野受命组建联合小队，前往信号源一探究竟。随着航程深入，队员们的记忆开始出现异常重叠，飞船系统也一次次记录下不存在的航线。当真相逐渐浮现，他们必须在自我认知与人类存亡之间做出抉择。影片以冷峻的硬科幻质感与深空孤独感，探讨记忆、文明与归属的主题。",
    category: "电影",
    subCategory: "科幻",
    region: "中国大陆",
    year: 2026,
    genres: ["科幻", "悬疑", "剧情"],
    director: "陈默",
    actors: ["林澈", "程野", "苏晚"],
    rating: 8.7,
    updateDate: "2026-10-12",
    episodes: "片长 132 分钟",
    hot: 9860,
    tags: ["硬科幻", "悬疑", "高口碑"],
  },
  {
    id: "1002",
    title: "暗夜追凶",
    cover: "https://readdy.ai/api/search-image?query=film%20noir%20crime%20movie%20poster%2C%20lone%20detective%20figure%20under%20rain%20in%20a%20dark%20neon%20city%20alley%2C%20orange%20streetlight%20glow%2C%20tense%20mood%2C%20high%20contrast%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1002&orientation=portrait",
    summary: "一桩尘封十年的悬案重新浮出水面，刑警队长在追凶路上直面自己的过去。",
    story: "十年前的一起连环杀人案因证据不足而搁浅，刑警队长陆峥始终无法释怀。当新的受害者出现，作案手法与当年如出一辙，他被重新拉回那段黑暗记忆。随着调查深入，线索指向一个与他关系密切的旧日同僚。在真相与情义之间，陆峥用一场没有退路的追凶，向所有被忽视的亡魂交出一份迟到的答卷。",
    category: "电影",
    subCategory: "悬疑",
    region: "中国香港",
    year: 2025,
    genres: ["犯罪", "悬疑", "动作"],
    director: "高永强",
    actors: ["陆峥", "何静", "老赵"],
    rating: 8.2,
    updateDate: "2026-10-11",
    episodes: "片长 118 分钟",
    hot: 9120,
    tags: ["犯罪", "烧脑", "港味"],
  },
  {
    id: "1003",
    title: "山河故人记",
    cover: "https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20drama%20movie%20poster%2C%20misty%20mountain%20range%20at%20dawn%20with%20a%20lone%20traveler%20in%20traditional%20robe%2C%20warm%20amber%20sunrise%2C%20poetic%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1003&orientation=portrait",
    summary: "三代人的迁徙与守望，勾勒出一幅跨越半世纪的中国家庭长卷。",
    story: "从北方山村到南方沿海，一个普通家庭在三代人的时间里经历了迁徙、分离与重逢。祖父守着老宅等待远行的儿子，父亲在改革浪潮中背井离乡，孙女则在城市里重新寻找根的坐标。《山河故人记》以克制而深情的镜头，记录时代洪流下个体的坚韧与牵挂。",
    category: "电影",
    subCategory: "剧情",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "历史", "家庭"],
    director: "李承安",
    actors: ["周德海", "沈兰", "周宁"],
    rating: 8.9,
    updateDate: "2026-10-10",
    episodes: "片长 145 分钟",
    hot: 8740,
    tags: ["文艺", "口碑佳作", "年代"],
  },
  {
    id: "1004",
    title: "极速边缘",
    cover: "https://readdy.ai/api/search-image?query=high%20speed%20racing%20action%20movie%20poster%2C%20sports%20car%20drifting%20with%20light%20trails%20on%20a%20night%20circuit%2C%20orange%20and%20amber%20speed%20lights%2C%20dynamic%20energy%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1004&orientation=portrait",
    summary: "退役赛车手为兄弟重返赛道，在极限竞速中挑战不可能的速度边界。",
    story: "曾经的天才车手韩野因一场事故退出职业赛车界。多年后，为救陷入危机的兄弟车队，他重新握上方向盘。对手是如日中天的新生代冠军，赛道是条件最严苛的海滨夜赛。《极速边缘》用真实的引擎轰鸣与紧凑剪辑，讲述一段关于荣耀、背叛与救赎的速度故事。",
    category: "电影",
    subCategory: "动作",
    region: "中国大陆",
    year: 2026,
    genres: ["动作", "运动", "竞速"],
    director: "吴峰",
    actors: ["韩野", "程一鸣", "林悦"],
    rating: 7.8,
    updateDate: "2026-10-09",
    episodes: "片长 124 分钟",
    hot: 8210,
    tags: ["热血", "赛车", "视觉爽片"],
  },
  {
    id: "1005",
    title: "星海拾梦",
    cover: "https://readdy.ai/api/search-image?query=romantic%20sci-fi%20movie%20poster%2C%20two%20silhouettes%20holding%20hands%20beneath%20a%20starry%20sky%20with%20a%20distant%20ringed%20planet%2C%20soft%20purple%20amber%20glow%2C%20dreamy%20tone%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1005&orientation=portrait",
    summary: "在两个平行时空之间，一对恋人用一段段记忆碎片寻找彼此。",
    story: "天文台研究员夏星在一次量子实验中意外与另一个时空的自己产生连接，而那个时空里，藏着已经离开的恋人顾海。为了留住逐渐消散的记忆，她在两个世界之间反复往返，试图拼凑出一个两人都能存在的时间线。《星海拾梦》是一部关于爱与遗憾的温柔科幻爱情片。",
    category: "电影",
    subCategory: "爱情",
    region: "中国大陆",
    year: 2025,
    genres: ["科幻", "爱情", "奇幻"],
    director: "苏婉",
    actors: ["夏星", "顾海"],
    rating: 8.0,
    updateDate: "2026-10-08",
    episodes: "片长 116 分钟",
    hot: 7890,
    tags: ["甜虐", "平行时空", "浪漫"],
  },
  {
    id: "1006",
    title: "长安夜行",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20wuxia%20movie%20poster%2C%20murder%20investigation%20in%20a%20lantern%20lit%20tang%20dynasty%20city%20at%20night%2C%20crimson%20and%20amber%20lanterns%2C%20mysterious%20mood%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1006&orientation=portrait",
    summary: "盛唐长安，一名夜行捕快在十二个时辰内追查一桩牵动朝局的离奇命案。",
    story: "上元灯节前夜，长安城接连发生诡异的命案，死者身份皆与一桩旧年密案有关。夜行捕快裴照奉命在十二个时辰之内查明真相。随着线索层层展开，他发现凶手真正想要动摇的，是整座城池的秩序。《长安夜行》以考究的盛唐市井美学，讲述一场关于正义与权力的暗夜追查。",
    category: "电影",
    subCategory: "动作",
    region: "中国大陆",
    year: 2024,
    genres: ["古装", "动作", "悬疑"],
    director: "张麟",
    actors: ["裴照", "柳娘", "崔大人"],
    rating: 8.4,
    updateDate: "2026-10-07",
    episodes: "片长 128 分钟",
    hot: 8350,
    tags: ["古装", "考究", "悬疑"],
  },
  {
    id: "1007",
    title: "都市浮生录",
    cover: "https://readdy.ai/api/search-image?query=modern%20urban%20chinese%20tv%20drama%20poster%2C%20young%20professionals%20walking%20in%20a%20glassy%20downtown%20at%20dusk%2C%20warm%20orange%20city%20lights%2C%20reflective%20mood%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1007&orientation=portrait",
    summary: "四位背景迥异的年轻人在同一座城市相遇，各自书写属于自己的浮生篇章。",
    story: "《都市浮生录》围绕四位合租在老旧公寓里的年轻人展开。金融精英沈知遥、独立摄影师方野、咖啡店主理人温瑶和小城青年阿哲，在事业、感情与理想的拉扯中彼此扶持。剧集以细腻的群像叙事，呈现当代都市青年的真实生存图景。",
    category: "电视剧",
    subCategory: "都市剧",
    region: "中国大陆",
    year: 2026,
    genres: ["都市", "情感", "职场"],
    director: "何景明",
    actors: ["沈知遥", "方野", "温瑶", "阿哲"],
    rating: 8.1,
    updateDate: "2026-10-13",
    episodes: "更新至第 28 集 / 全 36 集",
    hot: 10240,
    tags: ["热播", "群像", "都市"],
  },
  {
    id: "1008",
    title: "迷雾之城",
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20crime%20thriller%20tv%20series%20poster%2C%20foggy%20coastal%20city%20skyline%20at%20night%20with%20dim%20orange%20lamp%20glow%2C%20suspenseful%20cold%20tone%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1008&orientation=portrait",
    summary: "一封举报信掀开小城数十年的隐秘，记者与警察联手追查真相。",
    story: "沿海小城连续出现匿名举报信，内容直指当地盘踞多年的利益网络。调查记者苏晴与年轻刑警方宇在层层阻挠中越查越深，发现案件背后牵扯的远比想象中复杂。《迷雾之城》以扎实的推理结构与压抑的氛围，讲述普通人对抗黑暗的勇气。",
    category: "电视剧",
    subCategory: "悬疑剧",
    region: "中国大陆",
    year: 2025,
    genres: ["悬疑", "犯罪", "剧情"],
    director: "程远",
    actors: ["苏晴", "方宇", "老陈"],
    rating: 8.6,
    updateDate: "2026-10-12",
    episodes: "更新至第 20 集 / 全 24 集",
    hot: 9680,
    tags: ["强推理", "高能", "口碑"],
  },
  {
    id: "1009",
    title: "千秋家国",
    cover: "https://readdy.ai/api/search-image?query=period%20epic%20chinese%20family%20drama%20poster%2C%20old%20mansion%20courtyard%20in%20the%20republic%20era%20with%20warm%20golden%20sunset%20light%2C%20nostalgic%20tone%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1009&orientation=portrait",
    summary: "一个大家族在时代变革中的兴衰沉浮，书写家国与亲情的厚重长卷。",
    story: "故事横跨数十年，讲述南方望族沈家从鼎盛走向分流的过程。老一辈固守祖业，年轻一代投身时代洪流，家族成员在理想的碰撞中不断告别与重逢。《千秋家国》以厚重笔触描绘个体命运与家国变迁的交织。",
    category: "电视剧",
    subCategory: "年代剧",
    region: "中国大陆",
    year: 2024,
    genres: ["年代", "历史", "家庭"],
    director: "王立群",
    actors: ["沈国栋", "沈玉书", "林秋"],
    rating: 8.8,
    updateDate: "2026-10-06",
    episodes: "全 40 集",
    hot: 8450,
    tags: ["厚重", "年代", "群像"],
  },
  {
    id: "1010",
    title: "青春纪事",
    cover: "https://readdy.ai/api/search-image?query=bright%20youth%20school%20drama%20poster%2C%20students%20cycling%20along%20a%20tree-lined%20campus%20road%20in%20warm%20afternoon%20sunlight%2C%20nostalgic%20fresh%20tone%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1010&orientation=portrait",
    summary: "一群高中生在最美好的年纪里，经历成长、友情与懵懂的心动。",
    story: "《青春纪事》以高三这一年为背景，记录一群少年在学业压力与青春悸动之间的成长。他们有各自的烦恼与梦想，也在一次次考试、比赛和告别中学会承担。剧集用温暖明快的笔调，还观众一段闪闪发光的青春记忆。",
    category: "电视剧",
    subCategory: "青春剧",
    region: "中国大陆",
    year: 2025,
    genres: ["青春", "校园", "情感"],
    director: "许宁",
    actors: ["林一", "夏末", "周航"],
    rating: 7.9,
    updateDate: "2026-10-05",
    episodes: "更新至第 30 集 / 全 32 集",
    hot: 7620,
    tags: ["青春", "治愈", "校园"],
  },
  {
    id: "1011",
    title: "天籁之战",
    cover: "https://readdy.ai/api/search-image?query=music%20competition%20variety%20show%20poster%2C%20singer%20on%20a%20glowing%20stage%20surrounded%20by%20warm%20amber%20spotlights%2C%20energetic%20concert%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1011&orientation=portrait",
    summary: "顶尖歌手同台竞技，用一场场惊艳改编重新定义舞台。",
    story: "《天籁之战》邀请不同年代的歌手同台竞演，每期都需在限定时间内完成高难度改编。节目以专业音乐性与真实舞台表现力著称，选手之间的碰撞与致敬成为最大看点。",
    category: "综艺",
    subCategory: "音乐",
    region: "中国大陆",
    year: 2026,
    genres: ["音乐", "竞技"],
    director: "综艺制作组",
    actors: ["神秘唱将", "实力派歌手"],
    rating: 8.3,
    updateDate: "2026-10-13",
    episodes: "更新至第 9 期 / 全 12 期",
    hot: 7930,
    tags: ["音乐", "舞台", "高能改编"],
  },
  {
    id: "1012",
    title: "勇闯荒野",
    cover: "https://readdy.ai/api/search-image?query=outdoor%20adventure%20reality%20show%20poster%2C%20explorers%20hiking%20across%20a%20rugged%20mountain%20ridge%20at%20sunrise%2C%20warm%20orange%20sky%2C%20epic%20nature%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1012&orientation=portrait",
    summary: "明星嘉宾深入荒野，在极限环境中完成一次次生存挑战。",
    story: "《勇闯荒野》把嘉宾带到无人区、沙漠和雪山，在专业向导的带领下完成真实的野外生存任务。节目以写实的镜头记录挑战与协作，也展现人与自然相处的敬畏。",
    category: "综艺",
    subCategory: "真人秀",
    region: "中国大陆",
    year: 2025,
    genres: ["户外", "真人秀", "竞技"],
    director: "综艺制作组",
    actors: ["嘉宾团", "专业向导"],
    rating: 8.0,
    updateDate: "2026-10-11",
    episodes: "更新至第 6 期 / 全 10 期",
    hot: 7010,
    tags: ["户外", "生存", "团队"],
  },
  {
    id: "1013",
    title: "舌尖之上",
    cover: "https://readdy.ai/api/search-image?query=food%20documentary%20poster%2C%20close%20up%20of%20steaming%20traditional%20chinese%20dishes%20on%20a%20rustic%20wooden%20table%2C%20warm%20amber%20lighting%2C%20appetizing%20rich%20texture%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1013&orientation=portrait",
    summary: "走遍山川湖海，寻访中国人餐桌上最动人的味道与故事。",
    story: "《舌尖之上》以食物为线索，走访不同地域的厨师、家庭与市集，讲述一道道菜肴背后的生活方式与情感记忆。纪录片用克制而温暖的镜头，呈现中国人对味道与团聚的理解。",
    category: "纪录片",
    subCategory: "美食",
    region: "中国大陆",
    year: 2024,
    genres: ["美食", "人文"],
    director: "纪录影像团队",
    actors: ["各地厨师与家庭"],
    rating: 9.1,
    updateDate: "2026-10-04",
    episodes: "全 8 集",
    hot: 7320,
    tags: ["高分", "美食", "人文"],
  },
  {
    id: "1014",
    title: "蓝色星球志",
    cover: "https://readdy.ai/api/search-image?query=nature%20documentary%20poster%2C%20deep%20ocean%20with%20sunlight%20rays%20and%20a%20school%20of%20fish%2C%20teal%20water%20with%20warm%20surface%20light%2C%20majestic%20underwater%20scene%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1014&orientation=portrait",
    summary: "深海与极地之间，记录地球上最壮丽的自然奇观与生命奇迹。",
    story: "《蓝色星球志》历时数年拍摄，跨越四大洋与两极冰原，用超高画质记录海洋生物的生存智慧与自然界的宏大变迁。它不仅是一场视觉盛宴，也传递着保护地球的深刻呼唤。",
    category: "纪录片",
    subCategory: "自然",
    region: "英国",
    year: 2026,
    genres: ["自然", "科学"],
    director: "自然影像团队",
    actors: ["旁白讲述者"],
    rating: 9.4,
    updateDate: "2026-10-03",
    episodes: "全 6 集",
    hot: 7560,
    tags: ["震撼", "自然", "4K"],
  },
  {
    id: "1015",
    title: "归途列车",
    cover: "https://readdy.ai/api/search-image?query=emotional%20family%20drama%20movie%20poster%2C%20father%20and%20child%20on%20a%20rural%20train%20platform%20at%20dusk%2C%20warm%20amber%20sunset%20light%2C%20tender%20melancholic%20mood%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1015&orientation=portrait",
    summary: "一位父亲带着女儿踏上漫长归途，在旅途中修补疏离多年的亲情。",
    story: "常年在外打工的父亲老周，在女儿考上大学那年决定送她北上求学。一趟跨越三千公里的绿皮火车之旅，父子般陌生的两人在狭小车厢里慢慢打开心结。《归途列车》用平凡细节，讲述一段迟来的和解。",
    category: "电影",
    subCategory: "剧情",
    region: "中国大陆",
    year: 2023,
    genres: ["剧情", "家庭"],
    director: "郑安",
    actors: ["老周", "周小雨"],
    rating: 8.5,
    updateDate: "2026-10-02",
    episodes: "片长 108 分钟",
    hot: 6640,
    tags: ["现实题材", "温情", "父女"],
  },
  {
    id: "1016",
    title: "幻界之门",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20adventure%20movie%20poster%2C%20glowing%20ancient%20stone%20gateway%20in%20a%20magical%20forest%20with%20amber%20energy%20light%2C%20epic%20dramatic%20mood%2C%20rich%20detail%2C%20vertical%20composition&width=600&height=900&seq=ht-mv-1016&orientation=portrait",
    summary: "少年意外打开通往幻界的大门，为守护两个世界踏上冒险之旅。",
    story: "平凡的少年陆寻在祖宅发现一枚古老钥匙，由此打开了连接现实与幻界的门。幻界正面临崩坏危机，而钥匙正是维系两界平衡的关键。为了守护家人与新的伙伴，陆寻必须在两个世界之间来回奔走，学习掌控属于自己的力量。",
    category: "电影",
    subCategory: "奇幻",
    region: "中国大陆",
    year: 2026,
    genres: ["奇幻", "冒险", "家庭"],
    director: "方骏",
    actors: ["陆寻", "阿雅", "守门人"],
    rating: 7.6,
    updateDate: "2026-10-01",
    episodes: "片长 120 分钟",
    hot: 6480,
    tags: ["奇幻", "合家欢", "冒险"],
  },
];

export const hotKeywords = ["深空回响", "都市浮生录", "悬疑", "纪录片", "科幻", "综艺"];